import { Col, Switch, Form, Row } from "antd";
import { useTranslation } from "react-i18next";
import TextArea from "../UI/InputNumberComponent/TextArea";
import InputName from "../UI/InputNumberComponent/InputName";
type prop = {
  setName: any;
  warehouse: any;
  isEdit: () => boolean;
};
export const GeneralAdd = ({ setName, isEdit, warehouse }: prop) => {
  const [t] = useTranslation("common");
  const handleNameChange = (event: any) => {
    setName(event);
  };
  return (
    <>
      <Row>
        <Col span={6}>
          <Form.Item
            label={`${t("status")}`}
            name="isActive"
            valuePropName="checked"
            style={{ margin: "2px" }}
          >
            <Switch
              checkedChildren={`${t("active")}`}
              unCheckedChildren={`${t("inactive")}`}
              disabled={isEdit() ? false : true}
            />
          </Form.Item>

          <Form.Item
            name="name"
            label={`${t("warehouse")}`}
            rules={[
              {
                required: true,
                message: "warehouse is required",
              },
            ]}
          >
            <InputName maxLength={50} onChange={handleNameChange} />
          </Form.Item>
          <Form.Item name="location" label={`${t("location")}`}>
            <TextArea maxLength={500} />
          </Form.Item>
          <Form.Item name="description" label={`${t("description")}`}>
            <TextArea maxLength={500} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
